<template>
  <div>
    <div class="msg-main">
        <div class="msg-title">
          <h1>服务内容</h1>
          <a><img src="../../../assets/images/right-arrow-gray.png"></a>
        </div>
        <div class="msg-content">
          <div class="bg self-media-bg">
            <img src="../../../assets/images/self-media-front.png" class="front">
          </div>
          <div class="left-gap ad-in-bg bg">
            <img src="../../../assets/images/ad-in-front.png" class="front">
          </div>
          <div class="top-gap market-bg bg">
            <img src="../../../assets/images/market-front.png" class="front">
          </div>
          <div class="left-gap top-gap location-ad-bg bg">
            <img src="../../../assets/images/location-ad-front.png" class="front">
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceContent'
}
</script>

<style scoped lang="stylus">
  .msg-main
    margin: 0 auto
    margin-bottom: 124px
    max-width: 1200px;
    .msg-title
      margin-left: 71px;
      h1
        padding-top: 55px
        font-weight: 400
        font-size: 32px
        display: inline-block
        margin: 0
      a
        display: inline-block
        vertical-align: bottom
        img
          width: 37px
          margin-left: 30px
          vertical-align: bottom
    .msg-content
      margin: 60px 0 0 80px;
      .self-media-bg
        background-image: url("../../../assets/images/self-media-bg.png")
        background-position: center
        background-size: contain
      .ad-in-bg
        background-image: url("../../../assets/images/ad-in-bg.png")
        background-position: center
        background-size: contain
      .market-bg
        background-image: url("../../../assets/images/market-bg.png")
        background-position: center
        background-size: contain
      .location-ad-bg
        background-image: url("../../../assets/images/location-ad-bg.png")
        background-position: center
        background-size: contain
      div
        display: inline-block
        width: 512px
        height: 268px
        overflow: hidden
        text-align: center
        position: relative
        img
          display: inline-block
        .bg
          z-index: 998
        .front
          z-index: 999
          height: 193px
          margin-top: 42px
          &:hover
            height: 220px
            margin-top: 22px
      .left-gap
        margin-left: 18px
      .top-gap
        margin-top: 18px
</style>



// WEBPACK FOOTER //
// src/pages/home/components/ServiceContent.vue